/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const DESKTOP_BREAKPOINT_PX = 768;

/**
 * MarketingPanel
 *
 * Renders IPM content inside a sandboxed iframe that:
 *  - Has NO access to OLP cookies, DOM or application state (no allow-same-origin)
 *  - Has NO scripting (no allow-scripts)
 *  - Is completely isolated via srcdoc
 *
 * Shown only on desktop viewports (>= 768px). Hidden on mobile/tablet.
 */
function MarketingPanel({ ipmContent }) {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== 'undefined'
      && window.innerWidth >= DESKTOP_BREAKPOINT_PX,
  );
  const iframeRef = useRef(null);

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      `(min-width: ${DESKTOP_BREAKPOINT_PX}px)`,
    );

    const handleChange = (e) => setIsDesktop(e.matches);

    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  // Do not render on mobile / tablet viewports or when no content
  if (!isDesktop || !ipmContent) {
    return null;
  }

  return (
    <div
      className="hidden md:flex flex-1 items-stretch ms-6"
      data-testid="marketing-panel-container"
    >
      <iframe
        ref={ iframeRef }
        title="In-Product Marketing"
        className="w-full h-full rounded-2xl shadow-24 border-0"
        srcDoc={ ipmContent }
        sandbox=""
        referrerPolicy="no-referrer"
        data-testid="marketing-panel-iframe"
        aria-label="In-Product Marketing content"
      />
    </div>
  );
}

MarketingPanel.propTypes = {
  ipmContent: PropTypes.string,
};

MarketingPanel.defaultProps = {
  ipmContent: null,
};

export default MarketingPanel;
